import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentPropsWithoutRef } from 'react';

import { cn } from '@/lib/utils';

const fieldVariants = cva('group/field flex w-full gap-2 data-[invalid=true]:text-red-400', {
  variants: {
    orientation: {
      vertical: 'flex-col *:w-full [&>.sr-only]:w-auto',
      horizontal:
        'flex-row items-center has-[>[data-slot=field-content]]:items-start *:data-[slot=field-label]:flex-auto has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-0.75',
      responsive:
        'flex-col *:w-full @md/field-group:flex-row @md/field-group:items-center @md/field-group:*:w-auto @md/field-group:has-[>[data-slot=field-content]]:items-start @md/field-group:*:data-[slot=field-label]:flex-auto [&>.sr-only]:w-auto @md/field-group:has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-0.75',
    },
  },
  defaultVariants: {
    orientation: 'vertical',
  },
});

export type FieldProps = ComponentPropsWithoutRef<'div'> & VariantProps<typeof fieldVariants>;

const Field = ({ className, orientation = 'vertical', ...props }: FieldProps) => {
  return (
    <div
      role="group"
      data-slot="field"
      data-orientation={orientation}
      className={cn('data-disabled:cursor-not-allowed', fieldVariants({ orientation }), className)}
      {...props}
    />
  );
};

export default Field;
